"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPayDebtsNegative = function SvgBPayDebtsNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M72.035 143.504c-.95 0-1.908 0-2.873-.056a70.965 70.965 0 01-54.713-29.15 2.097 2.097 0 113.383-2.453c20.875 28.633 60.416 36.102 90.297 17.055 29.881-19.046 39.803-58.043 22.66-89.055a2.097 2.097 0 013.67-2.028 71.301 71.301 0 01-62.424 105.715v-.028zM9.99 105.043a2.098 2.098 0 01-1.881-1.167C-5.307 76.847-.256 44.3 20.72 22.609 41.698.92 74.058-5.22 101.52 7.284a2.097 2.097 0 01-1.734 3.817C73.941-.657 43.493 5.124 23.756 25.536 4.017 45.948-.737 76.574 11.882 102.01a2.097 2.097 0 01-.943 2.796 2.03 2.03 0 01-.95.238z"
  }), (0, _core.jsx)("path", {
    d: "M117.675 50.449a17.539 17.539 0 01-15.38-26.032l7.453-13.477a2.098 2.098 0 013.67 2.034l-7.424 13.47a13.372 13.372 0 002.432 16.078 13.344 13.344 0 0018.874-.378c4.187-4.366 4.92-11 1.79-16.175L115.27 3.188a2.097 2.097 0 013.565-2.181l13.827 22.802a17.539 17.539 0 01-15.008 26.64h.02zM71.888 97.563a44.102 44.102 0 01-38.16-21.6 2.097 2.097 0 113.614-2.097 40.362 40.362 0 0069.938-1.398 2.097 2.097 0 113.698 1.972 44.123 44.123 0 01-38.174 23.137l-.916-.014zM55.412 64.437a11.758 11.758 0 01-8.018-3.14 2.097 2.097 0 112.845-3.082 7.626 7.626 0 0010.577-.196 2.097 2.097 0 112.963 2.964 11.786 11.786 0 01-8.122 3.495l-.245-.041zM88.231 63.78a11.793 11.793 0 01-8.017-3.14 2.097 2.097 0 012.845-3.082 7.62 7.62 0 0010.61-.238 2.098 2.098 0 012.965 2.971 11.786 11.786 0 01-8.123 3.495l-.28-.007z"
  })));
};

var _default = SvgBPayDebtsNegative;
exports["default"] = _default;